import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import useAuthService from '@shared/hooks/useAuthService';
import appLogger from '@shared/logging/appLogger';
import { AdobePageName } from '@shared/types/adobe-analytics';
import importRemote from '@shared/utilities/federation/loadremote';
import React, { Suspense, useEffect } from 'react';

import PageLoader from '../../components/PageLoading';

const ContactUsRemote = React.lazy(() =>
    importRemote({
        remoteName: 'ContactUs',
        scope: 'remote_contact_us',
        module: 'Application',
        remoteUrlLocation: process.env.REMOTE_CONTACT_US,
    })
);

const ContactUs = () => {
    const { authService } = useAuthService();

    useEffect(() => {
        appLogger.logPageView({
            name: AdobePageName.contact,
            uri: `${window.location.href}`,
            refUri: `${document.referrer}`,
            properties: {
                ruleName: 'contactUsLoad',
            },
        });
    }, []);

    return (
        <LayoutContainer includeFooter={true}>
            <ErrorBoundary>
                <Suspense fallback={<PageLoader label="contact-us-loading" />}>
                    <ContactUsRemote authService={authService} />
                </Suspense>
            </ErrorBoundary>
        </LayoutContainer>
    );
};

export default ContactUs;
